export default "__VITE_ASSET__25892752__"